module.exports = __webpack_public_path__ + "img/souris.69252509.png";